import {
  ADD_CATEGORY,
  CLEAR_7DAYS_DATE,
  GET_7DAYS_DATE,
  GET_ALL_API,
  GET_ALL_API_FAILED,
  GET_ALL_API_SUCCESS,
  GET_DISTRIBUTION_API,
  GET_DISTRIBUTION_API_FAILED,
  GET_DISTRIBUTION_API_SUCCESS,
  GET_DIST_RETAILER_FILTER,
  GET_DIST_RETAILER_FILTER_FAILED,
  GET_DIST_RETAILER_FILTER_SUCCESS,
  GET_FETCH_RETAIL_CATEGORY,
  GET_FETCH_RETAIL_CATEGORY_FAILED,
  GET_FETCH_RETAIL_CATEGORY_SUCCESS,
  GET_FILTER_DATA,
  GET_FILTER_DATA_FAILED,
  GET_FILTER_DATA_SUCCESS,
  GET_FILTER_JC_AREA,
  GET_FILTER_JC_AREA_FAILED,
  GET_FILTER_JC_AREA_SUCCESS,
  GET_FILTER_SCHEME_NAME,
  GET_FILTER_SCHEME_NAME_FAILED,
  GET_FILTER_SCHEME_NAME_SUCCESS,
  GET_FILTER_SCHEME_TYPE,
  GET_FILTER_SCHEME_TYPE_FAILED,
  GET_FILTER_SCHEME_TYPE_SUCCESS,
  GET_RDS_API,
  GET_RDS_API_FAILED,
  GET_RDS_API_SUCCESS,
  GET_SALES_API,
  GET_SALES_API_FAILED,
  GET_SALES_API_SUCCESS,
  GET_SALES_CSV_API,
  GET_SALES_CSV_API_FAILED,
  GET_SALES_CSV_API_SUCCESS,
  GET_STOCK_API,
  GET_STOCK_API_FAILED,
  GET_STOCK_API_SUCCESS,
  GET_STOCK_CSV_API,
  GET_STOCK_CSV_API_FAILED,
  GET_STOCK_CSV_API_SUCCESS,
  GET_TILES,
  GET_TILES_FAILED,
  GET_TILES_SUCCESS,
  GET_TIMESTAMP,
  GET_TIMESTAMP_FAILED,
  GET_TIMESTAMP_SUCCESS,
  GET_USER_DATA,
  GET_USER_DATA_FAILED,
  GET_USER_DATA_SUCCESS,
  RESET_DATA,
  RESET_SALES,
  RESET_SCHEME,
  SEGREGATE_DATA_ROLE,
  SELECTED_OPTION_DATA,
  SET_HEADER_DATE_FROM,
  SET_HEADER_DATE_TO,
  SET_HEADER_UNIT,
  SET_STATE_BASED_ON_COOKIES,
  UPDATE_FILTER_VALUE,
  SHOW_ALERT_DEVICE,
  HIDE_ALERT_DEVICE,
  HIDE_ERROR,
  SHOW_ERROR,
  SET_RUN,
  UNSET_RUN,
  SET_SELECTED_SITE,
  RESET_FILTERS_TO_DEFAULT, // Home / back full filter reset (+ hierarchy reseed flag)
  RESET_HEADER_DATES_TO_CONFIG, // Logout: default header dates + unit
  CLEAR_DASHBOARD_HIERARCHY_RESEED, // After reseed or skip path
} from "../actions";
import {
  SHOW_HEADER,
  SHOW_SIDEBAR,
  SET_PAYOUT_DASHBOARD,
  UNSET_PAYOUT_DASHBOARD,
  SET_CLAWBACK_DASHBOARD,
  UNSET_CLAWBACK_DASHBOARD,
} from "../actions/action";
import {
  defaultSelectedOptionsFromFilteredArray,
  filterData,
  getDefaultHeaderDateRangeToday,
  getSalesSockObj,
  getTodaysDate,
  mapTokenToRoleId,
  partnerIdentityForPayouts,
  updatedSchemeFilter,
  validatePartnerRoleType,
} from "../../utils/common";
import config from "../../utils/config";

const initialHeaderDateRange = getDefaultHeaderDateRangeToday();

export const initialStateHome = {
  segregatedData: [],
  filterValue: {
    selectedRegion: "",
    selectedState: "",
    selectedRole: "",
    selectedRchain: "",
    selectedCategory: "",
    selectedPartnerRoleType: "",
    selectedPartnerRoleName: "",
    orgId: "",
    agentId: "",
    partnerName: "",
    name: "",
    // Initialize site from sessionStorage to persist user's site selection across page reloads
    site: (() => {
      try {
        const storedSite = sessionStorage.getItem("site");
        return storedSite || "";
      } catch (error) {
        // Handle cases where sessionStorage is not available (e.g., private browsing)
        console.warn("sessionStorage not available:", error);
        return "";
      }
    })(),
    sites: [],
    selectedSchemeType: "",
    selectedSchemeName: "",
    selectedRetailerFilter: "",
    selectedDistributor: "",
    selectedRetailer: "",
    selectedArea: "",
    selectedJC: "",
    selectedJP: "",
  },
  error: false,
  showHeader: false,
  showSidebar: false,
  isPayoutDashboard: {
    payout: false,
    clawback: false,
  },
  // error: null,
  shouldRun: 0,
  /**
   * Set true only inside RESET_FILTERS_TO_DEFAULT. DashboardHierarchyReseedListener consumes it
   * to call App.fetchAPI once after Home/back so Region/State/ZD defaults repopulate (mobility).
   */
  needsDashboardHierarchyReseed: false,
  hierarchyData: null,
  distributionTableData: null,
  stockTableData: null,
  salesTableData: null,
  SAN: "",
  headerSelectedDateFrom: initialHeaderDateRange.from,
  headerSelectedDateTo: initialHeaderDateRange.to,
  dateModule: "",
  headerUnit: {
    unit: "1000",
    label: "(K)",
  },
  filteredArray: [],
  partnerRoleType: "",
  partnerRoleValue: "",
  selectedOptionData: {},
  showCategory: false,
  showSchemeType: false,
  showSchemeName: false,
  showDistributors: false,
  showRetailers: false,
  isBusinessType: true,
  isChild: false,
  storedToken: null,
  sessionExpired: sessionStorage.getItem("isSessionExpired"),
  filterList: {
    loading: false,
    data: null,
    error: null,
  },
  filterSchemeType: {
    loading: false,
    data: null,
    error: null,
  },
  filterSchemeName: {
    loading: false,
    data: null,
    error: null,
  },
  getAllAPI: {
    loading: false,
    data: {},
    error: null,
    distributionObject: {},
    salesObject: {},
    stockObject: {},
    rechargeDistributionObject: {},
    devicePayoutObj: {},
    rechargePayoutObj: {},
    activationPayoutObj: {},
    potentialIncentiveEarningsObj: null,
    clawbackPayoutObj: {},
  },
  distributionObj: {
    loading: false,
    error: null,
    distributionTableData: {},
  },
  salesObj: {
    loading: false,
    error: null,
    salesTableData: {},
  },
  salesCsvObj: {
    loading: false,
    error: null,
    salesCsvData: {},
  },
  salesCsvLoading: {
    OWNBRAND: false,
    JIOFI: false,
    ACCESSORIES: false,
    JIOPHONE: false,
    PARTNER: false,
  },
  rdsObj: {
    loading: false,
    error: null,
    csvData: {},
  },
  csvLoading: {
    Billed: false,
    OnBoarded: false,
    LYF: false,
    JioFI: false,
    "Jio Phone": false,
    "Partner Brand": false,
    Accessories: false,
  },
  stockObj: {
    loading: false,
    error: null,
    stockData: {},
  },
  stockCSVObj: {
    loading: false,
    error: null,
    stockCSVData: {},
  },
  userData: {
    loading: false,
    error: null,
    data: [], //{}
  },
  tilesData: {
    loading: false,
    error: null,
    data: null,
  },
  timestamp: {
    loading: false,
    error: null,
    data: {},
  },
  showAlert: false,
};

export function homeReducer(state = initialStateHome, action) {
  switch (action.type) {
    case SET_RUN: {
      return {
        ...state,
        shouldRun: ++state.shouldRun,
      };
    }
    case UNSET_RUN: {
      return {
        ...state,
        shouldRun: 0,
      };
    }
    case RESET_FILTERS_TO_DEFAULT: {
      // Full reset for Home / back: clear hierarchy selections and scheme columns; keep identity fields via spread on filterValue.
      const src = state.filteredArray;
      const filteredArray =
        src && typeof src === "object" && !Array.isArray(src) ? { ...src } : {};
      delete filteredArray.Scheme_Type;
      delete filteredArray.Scheme;
      delete filteredArray.Distributors;
      delete filteredArray.Retailers;
      return {
        ...state,
        selectedOptionData:
          defaultSelectedOptionsFromFilteredArray(filteredArray),
        filterValue: {
          ...state.filterValue,
          selectedRegion: "",
          selectedState: "",
          selectedRole: "",
          selectedRchain: "",
          selectedCategory: "",
          selectedSchemeType: "",
          selectedSchemeName: "",
          selectedRetailerFilter: "",
          selectedDistributor: "",
          selectedRetailer: "",
          selectedArea: "",
          selectedJC: "",
          selectedJP: "",
        },
        // Keep header date range on Home/back (after Set) so APIs match the UI.
        headerSelectedDateFrom: state.headerSelectedDateFrom,
        headerSelectedDateTo: state.headerSelectedDateTo,
        headerUnit: {
          unit: "1000",
          label: "(K)",
        },
        showSchemeType: false,
        showSchemeName: false,
        showDistributors: false,
        showRetailers: false,
        filterSchemeType: {
          loading: false,
          data: null,
          error: null,
        },
        filterSchemeName: {
          loading: false,
          data: null,
          error: null,
        },
        filteredArray,
        shouldRun: 0,
        // Signal DashboardHierarchyReseedListener to run fetchAPI on next non-home route (mobility + businessType).
        needsDashboardHierarchyReseed: true,
      };
    }
    case RESET_HEADER_DATES_TO_CONFIG: {
      const range = getDefaultHeaderDateRangeToday();
      return {
        ...state,
        headerSelectedDateFrom: range.from,
        headerSelectedDateTo: range.to,
        headerUnit: {
          unit: "1000",
          label: "(K)",
        },
      };
    }
    case CLEAR_DASHBOARD_HIERARCHY_RESEED: {
      return {
        ...state,
        needsDashboardHierarchyReseed: false,
      };
    }
    case SHOW_ERROR: {
      return {
        ...state,
        error: true,
      };
    }
    case HIDE_ERROR: {
      return {
        ...state,
        error: false,
      };
    }
    case SET_PAYOUT_DASHBOARD: {
      return {
        ...state,
        isPayoutDashboard: {
          ...state.isPayoutDashboard,
          payout: true,
        },
      };
    }

    case UNSET_PAYOUT_DASHBOARD: {
      return {
        ...state,
        isPayoutDashboard: {
          ...state.isPayoutDashboard,
          payout: false,
        },
      };
    }

    case SET_CLAWBACK_DASHBOARD: {
      return {
        ...state,
        isPayoutDashboard: {
          ...state.isPayoutDashboard,
          clawback: true,
        },
      };
    }

    case UNSET_CLAWBACK_DASHBOARD: {
      return {
        ...state,
        isPayoutDashboard: {
          ...state.isPayoutDashboard,
          clawback: false,
        },
      };
    }

    case SHOW_ALERT_DEVICE: {
      return {
        ...state,
        showAlert: true,
      };
    }
    case HIDE_ALERT_DEVICE: {
      return {
        ...state,
        showAlert: false,
      };
    }
    case GET_TIMESTAMP:
      return {
        ...state,
        timestamp: {
          loading: true,
          error: null,
          data: state.timestamp.data,
        },
      };
    case GET_TIMESTAMP_SUCCESS:
      let tsObj = state.timestamp.data;
      tsObj[action.extraData] = action?.payload?.content?.latestTimestamp;

      return {
        ...state,
        timestamp: {
          loading: false,
          error: null,
          data: tsObj,
        },
      };
    case GET_TIMESTAMP_FAILED:
      return {
        ...state,
        timestamp: {
          loading: false,
          error: action.error,
          data: {},
        },
      };
    case SHOW_HEADER: {
      return {
        ...state,
        showHeader: action.payload,
      };
    }

    case SHOW_SIDEBAR: {
      return {
        ...state,
        showSidebar: action.payload,
      };
    }

    case GET_TILES:
      return {
        ...state,
        tilesData: {
          loading: true,
          error: null,
          data: null,
        },
      };
    case GET_TILES_SUCCESS:
      return {
        ...state,
        tilesData: {
          loading: false,
          error: null,
          data: action.payload
            ? {
                ...action.payload,
                content: (() => {
                  const seen = new Set();
                  return action.payload.content?.filter((item) => {
                    if (seen.has(item.moduleName)) {
                      return false; // Skip duplicate
                    }
                    seen.add(item.moduleName);
                    return true; // Keep first occurrence
                  });
                })(),
              }
            : null,
        },
      };
    case GET_TILES_FAILED:
      return {
        ...state,
        tilesData: {
          loading: false,
          error: action.error,
          data: null,
        },
      };
    case RESET_SALES:
      return {
        ...state,
        salesObj: {
          loading: false,
          error: null,
          salesTableData: {},
        },
      };
    case CLEAR_7DAYS_DATE:
      return {
        ...state,
        dateModule: "",
      };
    case GET_7DAYS_DATE:
      return {
        ...state,
        dateModule: "ESTEL",
      };
    case RESET_SCHEME:
      const newSelectedOptionData = JSON.parse(
        JSON.stringify(state.selectedOptionData),
      );
      delete newSelectedOptionData?.Scheme;
      delete newSelectedOptionData?.Scheme_Type;
      return {
        ...state,
        selectedOptionData: newSelectedOptionData,
      };
    case RESET_DATA:
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: null,
          distributionTableData: {},
        },
        salesObj: {
          loading: false,
          error: null,
          salesTableData: {},
        },
        stockObj: {
          loading: false,
          error: null,
          stockData: {},
        },
      };
    case SET_SELECTED_SITE:
      return {
        ...state,
        filterValue: {
          ...state.filterValue,
          site: action.payload,
        },
      };
    case SET_STATE_BASED_ON_COOKIES:
      // Validate that the stored site is still in the available sites list
      let storedSite = null;
      try {
        storedSite = sessionStorage.getItem("site");
      } catch (error) {
        console.warn("sessionStorage not available:", error);
      }
      const availableSites = action.payload.site || [];
      const isValidStoredSite =
        storedSite && availableSites.includes(storedSite);

      // Determine site based on TOKEN configuration
      let siteToSet;
      if (window.TOKEN === "Y") {
        // When TOKEN = "Y", set site to the first site from payload
        siteToSet = action.payload.site;
      } else {
        // When TOKEN ≠ "Y", use the existing logic
        siteToSet = isValidStoredSite
          ? storedSite
          : state.filterValue.site === ""
            ? action.payload.site?.[0]
            : state.filterValue.site;
      }

      return {
        ...state,
        filterValue: {
          ...state.filterValue,
          selectedRegion: action.payload.region,
          selectedState: action.payload.state,
          selectedRole: action.payload.role,
          selectedPartnerRoleType: mapTokenToRoleId(action.partnerRoleName),
          selectedPartnerRoleName: action.partnerRoleName,
          orgId: action.payload.orgId,
          name: action.payload.name,
          agentId:
            action.payload.role === "JPM"
              ? action.payload.orgId
              : action.payload.agentId,
          partnerName: action.payload.role,
          site: siteToSet,
          sites: action.payload.site,
          selectedArea: action.payload.area,
        },
        isBusinessType: validatePartnerRoleType(action.partnerRoleName),
        isChild: partnerIdentityForPayouts(action.partnerRoleName) === "2",
        partnerRoleValue: action.partnerRoleValue,
        partnerRoleType: action.partnerRoleName,
        SAN: sessionStorage.getItem("sAMAccountName"),
      };

    case GET_USER_DATA:
      return {
        ...state,
        userData: {
          loading: true,
          data: [],
          error: null,
        },
      };

    case GET_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case GET_USER_DATA_FAILED:
      return {
        ...state,
        userData: {
          loading: false,
          data: [],
          error: action.error,
        },
      };

    case GET_FILTER_DATA:
      return {
        ...state,
        filterList: {
          loading: true,
          data: null, //[],
          error: null,
        },
      };

    case GET_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case GET_FILTER_DATA_FAILED:
      return {
        ...state,
        filterList: {
          loading: false,
          data: null, //[],
          error: action.error,
        },
      };

    case SET_HEADER_DATE_FROM:
      return {
        ...state,
        headerSelectedDateFrom: action.payload,
      };

    case SET_HEADER_DATE_TO:
      return {
        ...state,
        headerSelectedDateTo: action.payload,
      };

    case SET_HEADER_UNIT:
      return {
        ...state,
        headerUnit: {
          unit: action.payload.unit,
          label: action.payload.label,
        },
      };

    case SEGREGATE_DATA_ROLE: {
      let filteredData = filterData(
        action.payload,
        state.filteredArray,
        state.filterList,
        state.partnerRoleType,
      );

      if (state.filterSchemeType?.data?.content?.length > 0) {
        const st = filteredData.Scheme_Type;
        const schemeTypeMissing =
          st === undefined ||
          st === null ||
          (Array.isArray(st) && st.length === 0);
        if (schemeTypeMissing) {
          filteredData = updatedSchemeFilter(
            "Scheme_Type",
            filteredData,
            state.filterSchemeType.data,
          );
        }
      }
      if (state.filterSchemeName?.data?.content?.length > 0) {
        const sc = filteredData.Scheme;
        const schemeNameMissing =
          sc === undefined ||
          sc === null ||
          (Array.isArray(sc) && sc.length === 0);
        if (schemeNameMissing) {
          filteredData = updatedSchemeFilter(
            "Scheme",
            filteredData,
            state.filterSchemeName.data,
          );
        }
      }

      return {
        ...state,
        filteredArray: filteredData,
      };
    }

    case GET_ALL_API:
      return {
        ...state,
        getAllAPI: {
          error: false,
          data: {},
          loading: true,
        },
      };

    case GET_ALL_API_SUCCESS:
      let getSalesStockObj = getSalesSockObj(action.payload);
      return {
        ...state,
        getAllAPI: {
          error: false,
          data: action.payload,
          loading: false,
          distributionObject: getSalesStockObj.distObj,
          salesObject: getSalesStockObj.salesObj,
          stockObject: getSalesStockObj.stockObj,
          rechargeDistributionObject: getSalesStockObj.rechargeDistObj,
          devicePayoutObj: getSalesStockObj.devicePayoutObj,
          rechargePayoutObj: getSalesStockObj.rechargePayoutObj,
          activationPayoutObj: getSalesStockObj.activationPayoutObj,
          potentialIncentiveEarningsObj: action.payload?.content.filter((row) =>
            window.PIE.includes(row.moduleId),
          )?.[0],
          clawbackPayoutObj: action.payload?.content?.find((item) =>
            item?.moduleName?.toLowerCase()?.includes("clawback"),
          ),
          retailerPerformance: action.payload?.content?.find(
            (item) =>
              item?.moduleName?.toLowerCase() === "retailer performance",
          ),
        },
      };

    case GET_ALL_API_FAILED:
      return {
        ...state,
        getAllAPI: {
          error: action.error,
          data: {},
          loading: false,
        },
      };

    case GET_DISTRIBUTION_API:
      return {
        ...state,
        distributionObj: {
          loading: true,
          error: null,
          distributionTableData: state.distributionObj.distributionTableData,
        },
        rdsObj: {
          loading: false,
          error: null,
          csvData: {},
        },
      };

    case GET_DISTRIBUTION_API_SUCCESS:
      let distTable = JSON.parse(
        JSON.stringify(state.distributionObj.distributionTableData),
      );
      distTable[action.extraData] = [action.payload.content];
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: null,
          distributionTableData: Object.assign(
            state.distributionObj.distributionTableData,
            distTable,
          ),
        },
      };

    case GET_DISTRIBUTION_API_FAILED:
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: action.error,
          distributionTableData: {},
        },
      };
    case GET_RDS_API:
      return {
        ...state,
        rdsObj: {
          loading: true,
          error: null,
          csvData: {},
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: true,
        },
      };

    case GET_RDS_API_SUCCESS:
      let distCsv = JSON.parse(JSON.stringify(state.rdsObj.csvData));
      distCsv[action.extraData + "$" + action.tab] = [action.payload.content];
      return {
        ...state,
        rdsObj: {
          loading: false,
          error: null,
          csvData: Object.assign(state.rdsObj.csvData, distCsv),
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: false,
        },
      };

    case GET_RDS_API_FAILED:
      return {
        ...state,
        rdsObj: {
          loading: false,
          error: action.error,
          csvData: {},
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: false,
        },
      };
    case GET_SALES_API:
      return {
        ...state,
        salesObj: {
          loading: true,
          error: null,
          salesTableData: state.salesObj.salesTableData,
        },
      };

    case GET_SALES_API_SUCCESS:
      let salesTable = JSON.parse(
        JSON.stringify(state.salesObj.salesTableData),
      );
      salesTable[action.extraData] = [action.payload.content];
      return {
        ...state,
        salesObj: {
          loading: false,
          error: null,
          salesTableData: Object.assign(
            state.salesObj.salesTableData,
            salesTable,
          ),
        },
      };

    case GET_SALES_API_FAILED:
      return {
        ...state,
        salesObj: {
          loading: false,
          error: action.error,
          salesTableData: {},
        },
      };
    case GET_SALES_CSV_API:
      return {
        ...state,
        salesCsvObj: {
          loading: true,
          error: null,
          salesCsvData: {},
        },
        salesCsvLoading: {
          ...state.salesCsvLoading,
          [action.tab]: true,
        },
      };

    case GET_SALES_CSV_API_SUCCESS:
      let salesCsv = JSON.parse(JSON.stringify(state.salesCsvObj.salesCsvData));
      salesCsv[action.extraData + "$" + action.tab] = [action.payload.content];
      return {
        ...state,
        salesCsvObj: {
          loading: false,
          error: null,
          salesCsvData: Object.assign(state.salesCsvObj.salesCsvData, salesCsv),
        },
        salesCsvLoading: {
          ...state.salesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_SALES_CSV_API_FAILED:
      return {
        ...state,
        salesCsvObj: {
          loading: false,
          error: action.error,
          salesCsvData: {},
        },
        salesCsvLoading: {
          ...state.salesCsvLoading,
          [action.tab]: false,
        },
      };
    case GET_STOCK_API:
      return {
        ...state,
        stockObj: {
          loading: true,
          error: null,
          stockData: state.stockObj.stockData,
        },
        stockCSVObj: {
          loading: true,
          error: null,
          stockCSVData: {},
        },
      };

    case GET_STOCK_API_SUCCESS:
      let stockTable = JSON.parse(JSON.stringify(state.stockObj.stockData));
      stockTable[action.extraData] = [action.payload.content];
      return {
        ...state,
        stockObj: {
          loading: false,
          error: null,
          stockData: Object.assign(state.stockObj.stockData, stockTable),
        },
      };

    case GET_STOCK_API_FAILED:
      return {
        ...state,
        stockObj: {
          loading: false,
          error: action.error,
          stockData: {},
        },
      };

    case GET_STOCK_CSV_API:
      return {
        ...state,
        stockCSVObj: {
          loading: true,
          error: null,
          stockCSVData: {},
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: true,
        },
      };
    case GET_STOCK_CSV_API_SUCCESS:
      return {
        ...state,
        stockCSVObj: {
          loading: false,
          error: null,
          stockCSVData: action.payload,
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: false,
        },
      };
    case GET_STOCK_CSV_API_FAILED:
      return {
        ...state,
        stockCSVObj: {
          loading: false,
          error: null,
          stockCSVData: {},
        },
        csvLoading: {
          ...state.csvLoading,
          [action.tab]: false,
        },
      };
    case UPDATE_FILTER_VALUE:
      return {
        ...state,
        filterValue: action.payload,
      };

    case SELECTED_OPTION_DATA:
      return {
        ...state,
        selectedOptionData: action.payload,
        showCategory: action.showCategory,
      };

    case GET_FILTER_SCHEME_TYPE:
      return {
        ...state,
        filterSchemeType: {
          loading: true,
          data: [],
          error: null,
        },
      };

    case GET_FILTER_SCHEME_TYPE_SUCCESS:
      let updatedFilteredArray = updatedSchemeFilter(
        "Scheme_Type",
        state.filteredArray,
        action.payload,
      );

      // console.log("filtered array", updatedFilteredArray);
      return {
        ...state,
        filteredArray: updatedFilteredArray,
        selectedOptionData: {
          ...state.selectedOptionData,
          Scheme_Type: action?.payload?.content?.[0],
        },
        showSchemeType: true,
        filterSchemeType: {
          loading: false,
          data: action.payload,
          error: null,
        },
        filterValue: {
          ...state.filterValue,
          // selectedDistributor:"",
          // agentId:"",
          // orgId:"",
          // selectedRole:"",
          // selectedSchemeName:"",
          selectedSchemeType: action?.payload?.content?.[0] ?? "",
        },
      };

    case GET_FILTER_SCHEME_TYPE_FAILED:
      return {
        ...state,
        filterSchemeType: {
          loading: false,
          data: [],
          error: action.error,
        },
      };

    case GET_FILTER_SCHEME_NAME:
      return {
        ...state,
        filterSchemeName: {
          loading: true,
          data: [],
          error: null,
        },
      };

    case GET_FILTER_SCHEME_NAME_SUCCESS: {
      let updatedFilteredArray1 = updatedSchemeFilter(
        "Scheme",
        state.filteredArray,
        action.payload,
      );
      const hasSchemeNames =
        action.payload?.content && action.payload.content.length > 0;
      const nextSelected = { ...state.selectedOptionData };
      if (hasSchemeNames) {
        nextSelected.Scheme = "ALL";
      } else {
        delete nextSelected.Scheme;
      }
      return {
        ...state,
        selectedOptionData: nextSelected,
        filteredArray: updatedFilteredArray1,
        showSchemeName: hasSchemeNames,
        filterSchemeName: {
          loading: false,
          data: action.payload,
          error: null,
        },
        filterValue: {
          ...state.filterValue,
          selectedSchemeName: "",
        },
      };
    }

    case GET_FILTER_SCHEME_NAME_FAILED:
      return {
        ...state,
        filterSchemeName: {
          loading: false,
          data: [],
          error: action.error,
        },
      };

    case GET_FETCH_RETAIL_CATEGORY:
      return {
        ...state,
      };

    case GET_FETCH_RETAIL_CATEGORY_SUCCESS:
      global.retailCategory = action.payload && action.payload.content;
      let updatedFilteredArray2 = updatedSchemeFilter(
        "Retail Category",
        state.filteredArray,
        action.payload,
      );
      return {
        ...state,
        filteredArray: updatedFilteredArray2,
        selectedOptionData: {
          ...state.selectedOptionData,
          "Retail Category": "ALL",
        },
        // showCategory: true
      };

    case GET_FETCH_RETAIL_CATEGORY_FAILED:
      return {
        ...state,
      };

    case ADD_CATEGORY:
      // let updatedFilteredArray2 = updatedSchemeFilter("Retail Category", state.filteredArray, state.categoryList);
      return {
        ...state,
        selectedOptionData: {
          ...state.selectedOptionData,
          "Retail Category": "ALL",
        },
      };

    case GET_DIST_RETAILER_FILTER:
      return {
        ...state,
      };

    case GET_DIST_RETAILER_FILTER_SUCCESS:
      let updatedArr; //updatedSchemeFilter("Scheme", state.filteredArray, action.payload);
      let showDistributors = state.showDistributors;
      let showRetailers = state.showRetailers;
      let selectedOptionData1 = state.selectedOptionData;
      if (action.extraData === "Distributor") {
        showDistributors = true;
        updatedArr = {
          ...updatedSchemeFilter(
            "Distributors",
            state.filteredArray,
            action.payload,
          ),
          Retailers: ["ALL"],
        };
        selectedOptionData1 = {
          ...state.selectedOptionData,
          Distributors: "ALL",
          Retailers: "ALL",
        };
      } else {
        showRetailers = true;
        updatedArr = updatedSchemeFilter(
          "Retailers",
          state.filteredArray,
          action.payload,
        );
        selectedOptionData1 = {
          ...state.selectedOptionData,
          Retailers: "ALL",
        };
      }
      return {
        ...state,
        selectedOptionData: selectedOptionData1,
        filteredArray: updatedArr,
        showDistributors,
        showRetailers,
        filterValue: {
          ...state.filterValue,
          ...(action.extraData === "Distributor" && {
            selectedDistributor: updatedArr?.["Distributors"]?.[0] ?? "",
            selectedRetailer: "ALL",
          }),
          ...(action.extraData !== "Distributor" && {
            selectedRetailer: updatedArr?.["Retailers"]?.[0] ?? "",
          }),
        },
      };

    case GET_DIST_RETAILER_FILTER_FAILED:
      return {
        ...state,
      };

    case GET_FILTER_JC_AREA:
      return {
        ...state,
      };

    case GET_FILTER_JC_AREA_SUCCESS:
      let opt = action.extraData === "JC" ? "RDS/ARD/MARD" : "JC";
      let selectedOptionData = state.selectedOptionData;
      if (action.extraData === "RDS/ARD/MARD" || action.extraData === "JP") {
        opt = "All/JC/JP";
        if (action.extraData === "JP") {
          opt = "All/JP";
        }
        selectedOptionData = {
          ...state.selectedOptionData,
          [opt]: "ALL",
        };
      }
      let JCJPArr = updatedSchemeFilter(
        opt,
        state.filteredArray,
        action.payload,
      );
      return {
        ...state,
        selectedOptionData,
        filteredArray: JCJPArr,
      };

    case GET_FILTER_JC_AREA_FAILED:
      return {
        ...state,
      };

    default:
      return state;
  }
}

export default homeReducer;
